export default "assets/images/chouette_filigrane-35904316.png";